import { io } from 'socket.io-client'

export default defineNuxtPlugin(() => {
  const socket = io('http://localhost:4000', {
    transports: ['websocket'],
    autoConnect: false,
  })

  return {
    provide: {
      socket,
    },
  }
})
